export enum InstitutionType{    
    PrimarySchool = 1,
    HighSchool = 4,
    SpecialEducationalInstitution = 13,
    StudentDormitory = 14,
    InstitutionForAdultEducation = 40,
    ArtSchool = 54,    
    Kindergarten = 55,
    InstitutionTUR = 56,
    College = 57
}